import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

type ToastType = 'info' | 'success' | 'warning' | 'error';

@Injectable({
  providedIn: 'root',
})
export class ToasterService {
  private readonly config = {
    enableHtml: true,
    positionClass: 'toast-bottom-right',
    timeOut: 2000,
    closeButton: false,
  };

  private readonly typeConfig = {
    info: { cardClass: 'info', ribbonClass: 'ribbon-primary' },
    success: { cardClass: 'success', ribbonClass: 'ribbon-success' },
    warning: { cardClass: 'warning', ribbonClass: 'ribbon-warning' },
    error: { cardClass: 'danger', ribbonClass: 'ribbon-danger' }
  };

  constructor(private toastrService: ToastrService) {}

  private generateHtml(type: ToastType, message: string, header: string, title?: string): string {
    const { cardClass, ribbonClass } = this.typeConfig[type];
    
    return `
      <div class="ribbon-wrapper card ${cardClass}">
        <div class="card-body">
          <div class="header">
            <div class="ribbon ribbon-clip ${ribbonClass}">${header}</div>
            <i class="fa fa-close" style="font-size:24px"></i>
          </div>
          ${title ? `<h6>${title}</h6>` : ''}
          <p>${message}</p>
        </div>
      </div>
    `;
  }

  private showToast(type: ToastType, message: string, header: string, title?: string): void {
    const html = this.generateHtml(type, message, header, title);
    this.toastrService.show(html, undefined, this.config);
  }

  info(message: string, header: string, title?: string): void {
    this.showToast('info', message, header, title);
  }

  success(message: string, header: string, title?: string): void {
    this.showToast('success', message, header, title);
  }

  warning(message: string, header: string, title?: string): void {
    this.showToast('warning', message, header, title);
  }

  error(message: string, header: string, title?: string): void {
    this.showToast('error', message, header, title);
  }

  clear(): void {
    this.toastrService.clear();
  }
}
